import { render, staticRenderFns } from "./MyPaymentsHead.vue?vue&type=template&id=71f5d1ea"
import script from "./MyPaymentsHead.vue?vue&type=script&lang=js"
export * from "./MyPaymentsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports